/** 환경 변수 fallback — .env 없이도 빌드 가능하도록 기본값 제공 */

export const ENV = {
  SITE_URL: import.meta.env.VITE_SITE_URL || 'https://dev.snacksaju.com',
  TOSS_CLIENT_KEY: import.meta.env.VITE_TOSS_CLIENT_KEY || 'test_gck_docs_Ovk5rk1EwkEbP0W43n07xlzm',
  KAKAO_CLIENT_ID: import.meta.env.VITE_KAKAO_CLIENT_ID || 'a1701239fd380675bd841b4e6a5eef60',
  GOOGLE_CLIENT_ID:
    import.meta.env.VITE_GOOGLE_CLIENT_ID ||
    '170409697099-5e4063bi24rs4923g6kqndlreu6lirb4.apps.googleusercontent.com',
  OAUTH_REDIRECT_URI:
    import.meta.env.VITE_OAUTH_REDIRECT_URI || 'http://localhost:3000/oauth/callback',
  ENABLE_MOCKS: import.meta.env.VITE_ENABLE_MOCKS === 'true',
  SENTRY_DSN:
    import.meta.env.VITE_SENTRY_DSN ||
    'https://f1a1254a5c8d70a1ac1503dffad3adb2@o4510855839154176.ingest.us.sentry.io/4510996760559616',
  SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development',
  POSTHOG_KEY:
    import.meta.env.VITE_PUBLIC_POSTHOG_KEY || 'phc_S4oSCIBDqtRtz5xvYSkovxul87oZc4U87qA76DrylCy',
  POSTHOG_HOST: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
  /** 로컬 또는 dev 환경 여부 */
  IS_DEV:
    import.meta.env.DEV || (import.meta.env.VITE_SITE_URL || '').includes('dev.snacksaju.com'),
} as const
